module.exports = fox._r("images/ico-bl.png", __webpack_public_path__ + "images/ico-bl.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/ico-bl.png
// module id = 1061
// module chunks = 4